export const CASE_STUDY_CLIENT_URL = "https://ozexteriors.com.au/";

export const CASE_STUDY_STAMP_LABEL = "CASE STUDY";

export const CASE_STUDY_STAMP_META = "POST-DEPLOYMENT";

export const CASE_STUDY_HEADLINE_ACCENT = "+6 Additional Appointments";

export const CASE_STUDY_HEADLINE_LINE2 = "Per Week";

export const CASE_STUDY_LEAD = {
  beforeLink: "After connecting a digital employee, ",
  afterLink:
    " started booking six more qualified appointments on the calendar every week.",
};

export const CASE_STUDY_SIDEBAR_META =
  "Real company · Australia · Weekly uplift after go-live";

export const CASE_STUDY_METRICS = [
  {
    value: "+6",
    label: "Additional appointments per week",
    sub: "Started after digital employee went live",
    highlight: true,
  },
  {
    value: "9 sec",
    label: "Response time",
    sub: "vs 30–40 min office",
    highlight: false,
  },
  {
    value: "100%",
    label: "After-hours capture",
    sub: "Outside business hours",
    highlight: false,
  },
];

export const CASE_STUDY_CLIENT = {
  initials: "OE",
  name: "Oz Exteriors",
  region: "Australia · Inbound lead handling",
};

export const CASE_STUDY_INTRO_PARTS = {
  beforeLink: "After connecting a digital employee, ",
  linkText: "Oz Exteriors",
  afterLink:
    " began booking +6 additional qualified appointments per week — captured in under 9 seconds, including outside business hours, while the office workflow relied on a typical 30–40 minute callback.",
};

export const CASE_STUDY_BEFORE_AFTER = {
  before: "30–40 min callback",
  after: "9 sec digital employee",
};

export const CASE_STUDY_OUTCOME =
  "Outcome: +6 additional appointments per week · after go-live";

export const CASE_STUDY_FOOTNOTE =
  "Example from one live deployment — weekly uplift varies by inbound volume and vertical.";

export const CASE_STUDY_EVIDENCE_LABEL = "EVIDENCE · POST-DEPLOYMENT";

export const CASE_STUDY_EVIDENCE_IMAGE = "/images/cases/ozexteriors.png";

export const CASE_STUDY_EVIDENCE_CAPTION =
  "Calendar & qualification logs · Oz Exteriors deployment";
